
import React from 'react'
import {
	Col,
	Container,
	Row
} from 'reactstrap'

import dashboardPlaceholder from '../../assets/utils/images/beta-version-2.jpg'

const BusinessDashboard = () =>
{
	return (
		<>
			<Container style={{ backgroundColor: '#ffffff' }} className="mt--6" fluid>
				<div style={{ minHeight: '50vh' }} className="header-body text-center mb-7">
					<Row className="justify-content-center">
						<Col className="px-5" lg="12">
							<img
								alt="..."
								className="navbar-brand-img"
								src={ dashboardPlaceholder }
								width="939px"
								height="588px"
							/>
						</Col>
					</Row>
				</div>
			</Container>
		</>
	)
}

export default BusinessDashboard
